<mat-list class="notifications-list">
	@for (notification of filteredNotifications(); track notification.id) {
		<mat-list-item
			lines="3"
			(click)="messageClicked(notification)"
			[class.unread]="!notification.isRead"
			[class.active]="notification.pk === isActive()"
			class="notification-item"
		>
			<mat-icon
				matListItemIcon
				[svgIcon]="notification.text ? 'chat' : notification.object.type"
			/>

			<div matListItemTitle>
				{{ notification.title }}
			</div>

			<div matListItemLine class="location">
				<cmms-locations-section
					[locationsInputList]="notification.locations"
					[editable]="false"
					[showAmount]="1"
				></cmms-locations-section>
				<div class="notification-created">
					{{ notification.created | dateAgo }}
				</div>
			</div>

			<div matListItemLine class="event-line">
				{{ notification.event }}{{ notification.text ? ':' : '' }}

				@if (notification.text) {
					@if (isHtml(notification.text)) {
						<p [innerHtml]="notification.text"></p>
					} @else {
						"{{ notification.text }}"
					}
				}
			</div>
		</mat-list-item>

		<mat-divider></mat-divider>
	}
	@if (loadingMoreNotifications$ | async) {
		<div class="loading-spinner">
			<mat-spinner diameter="30"></mat-spinner>
		</div>
	} @else {
		<div class="no-more-notifications">
			<mat-icon svgIcon="flag"></mat-icon>
			<p>
				{{ 'inbox_notifications_no_more_msg' | translate }}
			</p>
		</div>
	}
</mat-list>
